const SITE_NAME = "Nant Power";

/**
 * ACF returns an empty array (not an object) when no field group applies to a
 * post type, so normalise before reading a field off it.
 */
function acfFields(entity) {
  const acf = entity?.acf;
  return acf && !Array.isArray(acf) ? acf : {};
}

function cleanField(value) {
  return typeof value === "string" && value.trim() ? value.trim() : "";
}

export const useUtilities = () => {
  const getMetaSnippet = (content) => {
    if (!content) return "";
    const snippet = content.substring(0, 150);
    return snippet.slice(0, snippet.lastIndexOf(" ")) + "...";
  };

  /**
   * SEO title for a WordPress page/post/CPT entry, taken from the ACF
   * `seo_title` field when the editor has set one.
   *
   * @param entity   The WP REST object (page, post or CPT item).
   * @param fallback Title to use when the field is empty or absent.
   */
  const getSeoTitle = (entity, fallback) =>
    cleanField(acfFields(entity).seo_title) || cleanField(fallback) || SITE_NAME;

  /**
   * SEO description, taken from the ACF `seo_description` field when set.
   *
   * @param entity   The WP REST object (page, post or CPT item).
   * @param fallback Description to use when the field is empty or absent.
   */
  const getSeoDescription = (entity, fallback) =>
    cleanField(acfFields(entity).seo_description) || cleanField(fallback) || "";

  return { getMetaSnippet, getSeoTitle, getSeoDescription };
};
